// 引入请求拦截
import { requestInterceptors } from './requestInterceptors.js'
// 引入响应拦截
import { responseInterceptors } from './responseInterceptors.js'

// 初始化请求配置
export const Request = () => {
	uni.$uv.http.setConfig((defaultConfig) => {
	    //defaultConfig 为默认全局配置
	    defaultConfig.baseURL = uni.$sk.config.baseUrl //根域名
	    return defaultConfig
	})
	
	requestInterceptors();
	responseInterceptors();
	
	uni.addInterceptor('request', {
		complete(res) {
			uni.hideLoading();
		},
		
		fail(err) {
			console.log('fail', err);
		}
	});
	
}
